import React from 'react';
export function StatsBar() {
  const stats = [{
    label: 'Years Experience',
    value: '15+'
  }, {
    label: 'Properties Bought',
    value: '2k+'
  }, {
    label: 'Avg Closing Time',
    value: '14 Days'
  }, {
    label: 'Customer Rating',
    value: '4.9/5'
  }];
  return <section className="w-full bg-gray-50 py-24 px-6 lg:px-8 relative z-10" data-id="element-118">
      <div className="max-w-7xl mx-auto" data-id="element-119">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-120">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-start border-l-4 border-slate-600 pl-6" data-id="element-121">
              <span className="text-5xl lg:text-6xl font-black text-black tracking-tight mb-2" data-id="element-122">
                {stat.value}
              </span>
              <span className="text-lg font-bold text-gray-700 uppercase tracking-wider" data-id="element-123">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}